import InitNavigation from './initNavigation';
import InitThemeToggle from './initThemeToggle';
import InitAcademyDropdown from './initAcademyDropdown';
import InitAcademyFilters from './initAcademyFilters';
import InitAcademyResults from './initAcademyResults';
import InitAcademyLoadMore from './initAcademyLoadMore';
import InitAcademyAdmin from './initAcademyAdmin';
import InitAcademyFavorites from './initAcademyFavorites';
import InitAcademyTracker from './initAcademyTracker';
import InitAccountWithdraw from './initAccountWithdraw';
import InitAcademyTakedown from './initAcademyTakedown';
import InitAcademyImageFade from './initAcademyImageFade';

InitNavigation();
InitThemeToggle();
InitAcademyDropdown();
InitAcademyFilters();
InitAcademyResults();
InitAcademyLoadMore();
InitAcademyAdmin();
InitAcademyFavorites();
InitAcademyTracker();
InitAccountWithdraw();
InitAcademyTakedown();
InitAcademyImageFade();
